import { gaActions } from '../gaActionTypes';

// Consts
export const SERVER_ERROR = `[ERROR] ${gaActions.server} Server Error`;
export const ERROR_LOCKOUT = `[ERROR] ${gaActions.server} Lockout`;
export const ERROR_EXPIRED = `[ERROR] ${gaActions.server} Expired`;
export const ERROR_DISABLED = `[ERROR] ${gaActions.server} Disapled`;
export const ERROR_FORBIDDEN = '[ERROR] Forbidden';
